import { useDispatch } from 'react-redux';
import { getGGResponse, setReloadIcon } from '../../redux/authSlice';
import { useGoogleOneTapLogin } from '@react-oauth/google';
import { setTreeLoading } from './scripts/tree-slice';

const GoogleOneTapLogin = () => {
  const dispatch = useDispatch();

  const reloadIcon = () => {
    dispatch(setReloadIcon(true));
  };

  useGoogleOneTapLogin({
    onSuccess: async (response) => {
      const param = { res: response || '', callback: reloadIcon };
      const userInfo = await dispatch(getGGResponse(param));

      // // debug-console.log('GGOneTapUser: successed', userInfo);
      dispatch(setTreeLoading(true));
    },
    onError: () => {
      // debug-console.log('Login Failed');
    },
  });

  return null;
};

export default GoogleOneTapLogin;
